import React, { Component } from 'react';
import { FormGroup,Row,Col,Input,Label } from "reactstrap";
import { Button } from '../../../components';
import Select from "react-select";
import ColourSwatches from '../../../components/swatches/Colour';
import TextSwatches from '../../../components/swatches/Text';
import {connect} from 'react-redux';
import {editVariant,getVariant,onDismiss} from '../../../actions/variantActions';
import SweetAlert from 'sweetalert2-react';
import SimpleReactValidator from 'simple-react-validator';
const options = [];
class EditVariant extends Component {
    _id = 0;
    constructor (){
        super();
        this.state = {
            isMounted: false,
            isColour:true,
            attribute:'',
            code:'',
            attribute_values:[]
        }
        this.onDismissPopup = this.onDismissPopup.bind(this);
        this.validator = new SimpleReactValidator();
        this.child = React.createRef();
        this.child2 = React.createRef();
    }

    componentDidMount() {
        var urls = this.props.match.url.split('/');
        this._id = urls[urls.length - 1];
        this.setState({ isMounted: true }, () => {
          if (this.state.isMounted) {
         this.setState({ isMounted: false });
        {this.props.onGetAttribute(this._id)}
      }
      });
      }
      componentWillReceiveProps(nextProps,prevProps) {
        if(nextProps.attribute && !prevProps.attribute){
            var status = [];
            var swatches = [];
            if(typeof nextProps.attribute.attribute_values !== 'undefined' ) {
                swatches = nextProps.attribute.attribute_values.map(function(clr) {
            return { attribute_id:clr.attribute_id,value:clr.value,value_code:clr.value_code};
             });
            }
        var isColour = true;
        if(nextProps.attribute.type === 2) {
            var status = [ { value: "Colour", label: "Color",isColour:true }];
            isColour = true;
        }
        else {
            var status = [{ value: "Text", label: "Text",isColour:false }];
            isColour = false
        }
          this.setState({
            attribute:nextProps.attribute.attribute,
            code:nextProps.attribute.code,
            selectedOption:status,
            isColour:isColour,
            attribute_values:swatches
          })
        }
    }
    onDismissPopup(){
        this.props.onDismiss();
        this.props.onGetAttribute(this._id);
      }
    handleSubmit = (e) => {
        e.preventDefault();
        var type=1;
        var validation = false;
        if (this.state.isColour )
        {
            type=2;
            validation = this.child.current.validate();
        }
        else {
            type=1
            validation = this.child2.current.validate();
        }
       
        var data = {
          code: this.state.code,
          attribute: this.state.attribute,
          type:type,
          attribute_values: this.state.attribute_values
        };

        if( this.validator.allValid() && validation){
            data['attribute_id'] = parseInt(this._id);
            this.props.onEditAttribute(data);
          }
          else {
            this.validator.showMessages();
            this.forceUpdate();
          }  
    }
      //loader
      getLoder() {
        let classes = "bt-loader ";
        classes += this.props.loadbrand || this.props.loading ? 'bt-show' : 'bt-hide';
        return classes;
      }


handleChange = (selectedOption) => {
    this.setState({ isColour:!this.state.isColour, attribute_values:[] });
  }
    render() { 
        const { selectedOption } = this.state;
        return ( 
            <div>
                <div className="content">
                <div className={this.getLoder()}></div>
                <div className="form-section">
                <form onSubmit ={(e)=>this.handleSubmit(e)}>
                <div className="form-border-wrapper">
                <Row className="pad">
                        <Col md="4">
                        <FormGroup>
                          <Label className="control-label">Variant Name</Label>
                          <Input type="text" value={this.state.attribute} onChange={(e)=>this.setState({attribute:e.target.value})} placeholder="Type here"/>
                          <div className="errorMsg">{this.validator.message('attribute', this.state.attribute, 'required')}</div>
                        </FormGroup>
                        </Col>
                        <Col md="4">
                        <FormGroup>
                          <Label className="control-label">Variant Type</Label>
                          <Select value={selectedOption} onChange={this.handleChange} options={options} defaultValue={[options[0]]} />
                        </FormGroup>
                        </Col>
                        <Col md="4">
                        <FormGroup>
                          <Label className="control-label">Variant Code</Label>
                          <Input type="text" value={this.state.code} onChange={(e)=>this.setState({code:e.target.value})} placeholder="Type here" />
                          <div className="errorMsg">{this.validator.message('code', this.state.code, 'required')}</div>
                        </FormGroup>
                        </Col>
                        <Col md="8">
                            <div className="inner-table-wrapper">
                            {this.state.isColour ? this.renderColourSelect() :this.renderTextSelect()}
                           
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="submit-wrapper">
                <Button className="btn-submit" >Save</Button>
                </div>
                </form>
                <SweetAlert
                  show={this.props.status && this.props.popup}
                  title="Success"
                  text={this.props.message}
                  onConfirm={this.onDismissPopup}
                  />
                  <SweetAlert
                  show={ !this.props.status && this.props.popup}
                  title="Error"
                  type="error"
                  text={this.props.message}
                  onConfirm={this.onDismissPopup}
                  />
                </div>
              
                </div>
            </div>
         )
    }
    renderColourSelect(){
        return (
            <ColourSwatches onChangeColor={(value)=>this.addColor(value)} 
            attribute_values={this.state.attribute_values} isEditing={true} ref={this.child}/>
        )
    }

    addColor= (value)=>{
        this.setState({
            attribute_values:value
        })
    }

    addText = (value) => {
        this.setState({
            attribute_values:value
        });
    }
    
    renderTextSelect (){
        return (
           <TextSwatches onChangeText={(value)=>this.addText(value)} 
           attribute_values={this.state.attribute_values} isEditing={true} ref={this.child2}/>
        )
    }
}

const mapStateToProps = (state) => ({
    loading: state.variantReducer.loading,
    status:state.variantReducer.status,
    message:state.variantReducer.message,
    popup:state.variantReducer.popup,
    loadattr:state.variantReducer.loadattr,
    attribute:state.variantReducer.variant

});

const mapDispatchToProps = (dispatch) => ({
    onEditAttribute:(data)=>{
        dispatch(editVariant(data))
      },
      onGetAttribute:(attr_id)=>{
        dispatch(getVariant(attr_id))
      },
      onDismiss:()=>{
        dispatch(onDismiss())
      }
});

export default connect (mapStateToProps,mapDispatchToProps)(EditVariant);
 
